'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Base = require('../Base/Base');

var _Base2 = _interopRequireDefault(_Base);

var _Icon = require('../Icon/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./ChipList.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChipList = function (_Component) {
  _inherits(ChipList, _Component);

  function ChipList(props) {
    _classCallCheck(this, ChipList);

    var _this = _possibleConstructorReturn(this, (ChipList.__proto__ || Object.getPrototypeOf(ChipList)).call(this, props));

    _this.handleExpand = function () {
      if (_this.state.isExpandable) {
        _this.setState({ isExpanded: !_this.state.isExpanded });
      }
    };

    _this.chipList = _react2.default.createRef();
    _this.state = {
      isExpanded: false,
      isExpandable: false
    };
    return _this;
  }

  _createClass(ChipList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _chipList$current = this.chipList.current,
          clientHeight = _chipList$current.clientHeight,
          scrollHeight = _chipList$current.scrollHeight;


      if (scrollHeight > clientHeight * 2) {
        this.setState({ isExpandable: true });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          label = _props.label,
          size = _props.size;
      var _state = this.state,
          isExpanded = _state.isExpanded,
          isExpandable = _state.isExpandable;


      var childrenWithSize = _react2.default.Children.map(children, function (child) {
        return _react2.default.cloneElement(child, { size: size });
      });

      var classes = (0, _classnames2.default)('ax-chiplist', 'ax-chiplist--' + size, { 'ax-chiplist--expanded': isExpanded });

      var labelClasses = (0, _classnames2.default)('ax-chiplist-label', 'ax-chiplist-label--' + size, { 'ax-chiplist--expandable': isExpandable });

      return _react2.default.createElement(
        _Base2.default,
        { baseRef: this.chipList, className: classes },
        _react2.default.createElement(
          'div',
          { className: labelClasses, onClick: this.handleExpand },
          label,
          isExpandable && _react2.default.createElement(_Icon2.default, { inline: true, name: isExpanded ? 'chevron-up' : 'chevron-down', spaceLeft: 'x1' })
        ),
        childrenWithSize
      );
    }
  }]);

  return ChipList;
}(_react.Component);

ChipList.propTypes = {
  /** Array of Chip components */
  children: _propTypes2.default.node.isRequired,
  /** Label of the List */
  label: _propTypes2.default.string,
  /** Size of the chips in the chip list */
  size: _propTypes2.default.oneOf(['small', 'medium', 'large'])
};
ChipList.defaultProps = {
  size: 'medium'
};
exports.default = ChipList;